import API from './API';
import { getParamsByOptions } from 'utils/functions';

const AdminPaymentAPI = {
	index: options => API.get('/admin/payments' + getParamsByOptions(options)),
};

export default AdminPaymentAPI;
